<template>
  <div class="animated fadeIn">
    <b-card>
      <b-form
         @submit.stop.prevent="onSubmit"
        novalidate
      >
        <b-row>
          <b-col cols="6">
              <b-form-group label="Mac Address" label-for="mac">
                  <b-form-input
                    id="mac"
                    type="text"
                    :state="chkState('mac')"
                    v-model.lazy.trim="$v.form.mac.$model"
                    aria-describedby="liveFeedbackMac"
                    placeholder="Enter Mac Address"
                    autofocus
                  />
                  <b-form-invalid-feedback id="liveFeedbackName">
                    This is a required field
                  </b-form-invalid-feedback>
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="6">
              <b-form-group label="Description" label-for="description">
                  <b-form-input
                    id="description"
                    type="text"
                    :state="chkState('description')"
                    v-model.lazy.trim="$v.form.description.$model"
                    placeholder="Description"
                  />
              </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-form-group label="Enabled?"  label-for="enabled">
            <b-form-checkbox :state="chkState('enabled')" v-model="$v.form.enabled.$model" id="enabled" name="enabled" switch>
            </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-button ref="submitButton" type="submit" variant="primary" :disabled="$v.form.$invalid">
              Save
            </b-button>
          </b-col>
          <b-col>
            <b-button class="ml-1" type="reset" @click="onCancel">Close</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>
<script>


import Vue from 'vue'
import VueLodash from 'vue-lodash'
import map from 'lodash/map'
import {
  mapState,
  mapActions
} from 'vuex'
import { validationMixin } from "vuelidate";
import filter from 'lodash/filter'
import { required, maxLength } from "vuelidate/lib/validators";


const formShape = {
  mac: null,
  description: null,
  enabled:null
}

export default{
  name: 'DeviceEdit',
  props: {
    selectedDevice: {
      type: Object,
      default: null,
    },
  },
  data: function() {
    return {
      form: Object.assign({}, formShape),
      submitted: false,
    }
  },

  validations: {
    form: {
      mac: {
        required,
        maxLength : maxLength(45)

        },
        description:{
          required: false,
        },
        enabled:{
          required
        },
    }
  },

  computed: {
  },

  methods:{
    onCancel() {
      this.onReset();
      this.$emit('cancel')
    },
    onSubmit(){

      if(this.validate() & this.submitted == false){
        this.$nextTick(() => {
          this.submitted = true
          let params = {
            id: this.form.id,
            description: this.form.description,
            mac: this.form.mac,
            enabled: this.form.enabled,
          };
          this.$store
            .dispatch('pos/updateDevice', params)
            .then(response => {
              if (response.data.success == false) {
                this.showErrorMsg({
                  message: response.data.error
                })
              } else {
                this.showSuccessMsg({
                  message: 'Record updated successfully.'
                });
                this.$emit('success')
              }
              this.submitted = false;

            })
            .catch(error => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else if (error.response.status == 422) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              } else {
                this.showErrorMsg({ message: 'Something went wrong. Please contact administrator.' })
              }
              this.submitted = false;
            })
        })

      }

    },
    validate() {
      this.$v.$touch()
      return !this.$v.form.$anyError
    },

    chkState(name){
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onReset() {
      this.form = formShape
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },


  },

  created: function(){
    this.form = Object.assign({}, formShape);


    this.form.description = this.selectedDevice.description;
    this.form.id = this.selectedDevice.id;
    this.form.mac = this.selectedDevice.mac;
    this.form.enabled = this.selectedDevice.enabled == 1 ? true : false;
  }
}
</script>

<style media="screen">
  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span{
    width:100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

  }

  .borderCard{
    border: 1px solid #e3e8ec;
  }
</style>
